// import React, { ReactElement, useEffect, useRef } from "react";
// import ButtonStyled from "../../../components/common/ButtonStyled";
// import Input from "../../../components/Input";
// import { UseFormRegister, FieldErrors, UseFormSetValue } from "react-hook-form";
// type Props = {
//   onClose: React.MouseEventHandler<HTMLButtonElement>;
//   title: string;
//   children: React.ReactNode;
//   actionButtonText: string | React.ReactElement | false | undefined;
//   open: boolean;
//   actionButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
//   cancelButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
//   actionButtonExtraClasses?: string | undefined;
//   actionButtonProps?: React.ComponentProps<"button">;
//   actionButtonIcon?: ReactElement | false | undefined;
//   closeButtonText?: string;
//   hideFooter?: boolean;
//   isPending?: boolean;
//   showFooter?: boolean;
//   register: UseFormRegister<any>;
//   errors: FieldErrors;
//   setValue: UseFormSetValue<any>;
//   defaultValues?: any;
//   readOnly?: boolean;
// };

// const RoleAccessSection = ({
//   register,
//   errors,
//   setValue,
//   defaultValues,
//   readOnly,
//   open,
//   actionButtonText,
//   actionButtonExtraClasses,
//   actionButtonIcon,
//   actionButtonOnClick,
//   actionButtonProps,
//   children,
//   isPending,
// }: Props) => {
//   const globalSelectAllRef = useRef<HTMLInputElement>(null);
//   useEffect(() => {
//     if (!globalSelectAllRef.current || readOnly) return;
//   }, [readOnly]);

//   const handleGlobalSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const checked = e.target.checked;
//     setValue("selectAllGlobal", checked, { shouldDirty: true });
//   };
//   return (
//     <>
//       {open && (
//         <div className="">
//           <div className="flex justify-between items-center h-[61.5px] px-4 border-b border-[#000000]/10 flex-wrap pb-[7rem] xl:pb-0">
//             <div>
//               {" "}
//               <div className=" space-y-2 lg:pt-1 xl:pt-0">
//                 {!readOnly ? (
//                   <Input
//                     name="roleName"
//                     type="text"
//                     title="Role Name"
//                     placeholder="Manager"
//                     register={register}
//                     error={errors.roleName}
//                     validation={{
//                       required: "Role is required",
//                       pattern: {
//                         value: /^(?!\d+$)[A-Za-z0-9\s]+$/,
//                         message:
//                           "Role Name must contain letters (not only numbers)",
//                       },
//                       validate: (value) =>
//                         value.trim().length > 0 || "Spaces are not allowed",
//                     }}
//                     disabled={readOnly}
//                     defaultValue={defaultValues?.roleName || ""}
//                     className="flex space-x-4 items-center w-96"
//                   />
//                 ) : (
//                   <p className="text-lg font-medium">
//                     {defaultValues?.roleName || ""}
//                   </p>
//                 )}
//               </div>
//             </div>
//             <div className="flex items-center gap-6 mt-4 xl:mt-0">
//               <label className="flex items-center space-x-2 cursor-pointer">
//                 <label className="relative flex items-center ">
//                   <input
//                     type="checkbox"
//                     disabled={readOnly}
//                     {...register("multipleAccessWarehouse")}
//                     defaultChecked={
//                       defaultValues?.multipleAccessWarehouse || false
//                     }
//                     className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all
//              bg-white checked:bg-[#FBD037] checked:text-white"
//                   />
//                   <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                     ✓
//                   </span>
//                 </label>
//                 <span className="text-sm">Multiple Access Warehouse</span>
//               </label>
//               {actionButtonText && (
//                 <ButtonStyled
//                   value={actionButtonText}
//                   onClick={actionButtonOnClick}
//                   extraClasses={actionButtonExtraClasses}
//                   extraProps={actionButtonProps}
//                   icon={actionButtonIcon}
//                   isPending={isPending}
//                 />
//               )}
//               <label className="flex items-center space-x-2 cursor-pointer">
//                 <label className="relative flex items-center">
//                   <input
//                     type="checkbox"
//                     {...register("globalSelectAll")}
//                     disabled={readOnly}
//                     className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037] checked:text-white indeterminate:bg-[#FBD037]/70 indeterminate:border-[#FBD037]/70"
//                   />
//                   <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 ... top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
//                     ✓
//                   </span>
//                 </label>
//                 <span className="text-sm font-medium">
//                   Select All Permissions
//                 </span>
//               </label>
//             </div>
//           </div>

//           {children}
//         </div>
//       )}
//     </>
//   );
// };

// export default RoleAccessSection;

import React, { ReactElement, useEffect, useRef } from "react";
import ButtonStyled from "../../../components/common/ButtonStyled";
import Input from "../../../components/Input";
import { UseFormRegister, FieldErrors, UseFormSetValue } from "react-hook-form";
import { T, useLanguage } from "../../../context/LanguageContext";

type Props = {
  onClose: React.MouseEventHandler<HTMLButtonElement>;
  title: string;
  children: React.ReactNode;
  actionButtonText: string | React.ReactElement | false | undefined;
  open: boolean;
  actionButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  cancelButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>;
  actionButtonExtraClasses?: string | undefined;
  actionButtonProps?: React.ComponentProps<"button">;
  actionButtonIcon?: ReactElement | false | undefined;
  closeButtonText?: string;
  hideFooter?: boolean;
  isPending?: boolean;
  showFooter?: boolean;
  register: UseFormRegister<any>;
  errors: FieldErrors;
  setValue: UseFormSetValue<any>;
  defaultValues?: any;
  readOnly?: boolean;
  hideMultipleAccess?: boolean;
};

const RoleAccessSection = ({
  register,
  errors,
  setValue,
  defaultValues,
  readOnly,
  open,
  actionButtonText,
  actionButtonExtraClasses,
  actionButtonIcon,
  actionButtonOnClick,
  actionButtonProps,
  children,
  isPending,
  hideMultipleAccess = false,
}: Props) => {
  const { t } = useLanguage();
  const globalSelectAllRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!globalSelectAllRef.current || readOnly) return;
  }, [readOnly]);

  return (
    <>
      {open && (
        <div className="">
          <div className="h-full px-4 py-3.5 border-b border-[#000000]/10 space-y-2">
            <div className="flex flex-wrap items-center w-full gap-4">
              <div className="space-y-2 lg:pt-1 xl:pt-0">
                {!readOnly ? (
                  <Input
                    name="roleName"
                    type="text"
                    title="Role Name"
                    placeholder="Manager"
                    register={register}
                    error={errors.roleName}
                    validation={{
                      required: "Role is required",
                      pattern: {
                        value: /^(?!\d+$)[A-Za-z0-9\s]+$/,
                        message:
                          "Role Name must contain letters (not only numbers)",
                      },
                      validate: (value) =>
                        value.trim().length > 0 || "Spaces are not allowed",
                    }}
                    disabled={readOnly}
                    defaultValue={defaultValues?.roleName || ""}
                    className="flex space-x-4 items-center w-96"
                  />
                ) : (
                  <p className="text-lg font-medium">
                    {defaultValues?.roleName || ""}
                  </p>
                )}
              </div>

              {!hideMultipleAccess && (
                <div className="flex items-center justify-between">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <span className="text-xs text-gray-500"><T>Single</T></span>

                    <div className="relative">
                      <input
                        type="checkbox"
                        disabled={readOnly}
                        {...register("multipleAccessWarehouse")}
                        defaultChecked={
                          defaultValues?.multipleAccessWarehouse || false
                        }
                        className="sr-only peer"
                      />
                      <div
                        className="w-12 h-6 bg-gray-300 rounded-full 
          peer-checked:bg-[#FBD037] 
          transition-colors duration-300
          peer-disabled:opacity-50"
                      />
                      <div
                        className="absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md
          transition-transform duration-300
          peer-checked:translate-x-6"
                      />
                    </div>
                    <span className="text-xs text-gray-700 font-medium">
                      <T>Multiple</T>
                    </span>
                  </label>
                </div>
              )}
              {actionButtonText && (
                <ButtonStyled
                  value={actionButtonText}
                  onClick={actionButtonOnClick}
                  extraClasses={actionButtonExtraClasses}
                  extraProps={actionButtonProps}
                  icon={actionButtonIcon}
                  isPending={isPending}
                />
              )}
            </div>

            <label className="flex items-end justify-end space-x-2 cursor-pointer">
              <label className="relative flex items-center">
                <input
                  type="checkbox"
                  {...register("globalSelectAll")}
                  disabled={readOnly}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all bg-white checked:bg-[#FBD037] checked:text-white indeterminate:bg-[#FBD037]/70 indeterminate:border-[#FBD037]/70"
                />
                <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  ✓
                </span>
              </label>
              <span className="text-sm font-medium">
                <T>Select All Permissions</T>
              </span>
            </label>
          </div>

          {children}
        </div>
      )}
    </>
  );
};

export default RoleAccessSection;
